import { useState, useRef } from "react";
import { Upload, X } from "lucide-react";
import api from "../../services/api";

export default function BannerForm({ onSave, onCancel }) {
  var titleState = useState("");
  var title = titleState[0];
  var setTitle = titleState[1];
  var descState = useState("");
  var desc = descState[0];
  var setDesc = descState[1];
  var linkState = useState("");
  var link = linkState[0];
  var setLink = linkState[1];
  var orderState = useState(0);
  var order = orderState[0];
  var setOrder = orderState[1];
  var fileState = useState(null);
  var file = fileState[0];
  var setFile = fileState[1];
  var previewState = useState(null);
  var preview = previewState[0];
  var setPreview = previewState[1];
  var savingState = useState(false);
  var saving = savingState[0];
  var setSaving = savingState[1];
  var inputRef = useRef(null);

  function handleFile(e) {
    var f = e.target.files[0];
    if (!f) return;
    setFile(f);
    var reader = new FileReader();
    reader.onload = function(ev) { setPreview(ev.target.result); };
    reader.readAsDataURL(f);
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!file) return;
    setSaving(true);
    var fd = new FormData();
    fd.append("title", title);
    fd.append("description", desc);
    fd.append("link_url", link);
    fd.append("order", order.toString());
    fd.append("file", file);
    api.post("/banners", fd, { headers: { "Content-Type": "multipart/form-data" } }).then(function() { onSave(); }).finally(function() { setSaving(false); });
  }

  return (
    <div className="bg-white rounded-xl p-5 shadow-sm border mb-6" data-testid="banner-form">
      <h3 className="text-sm font-bold text-[#0A2F3D] mb-4">Novo Banner</h3>
      <form onSubmit={handleSubmit} className="space-y-3">
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Titulo</label>
            <input required value={title} onChange={function(e) { setTitle(e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="banner-title-input" />
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">Link (opcional)</label>
            <input value={link} onChange={function(e) { setLink(e.target.value); }} placeholder="https://..." className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="banner-link-input" />
          </div>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Descricao (opcional)</label>
          <input value={desc} onChange={function(e) { setDesc(e.target.value); }} className="w-full px-3 py-2 border rounded-lg text-sm" data-testid="banner-desc-input" />
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Imagem do Banner</label>
          {preview ? (
            <div className="relative w-full h-36 rounded-lg overflow-hidden bg-gray-100">
              <img src={preview} alt="Preview" className="w-full h-full object-cover" />
              <button type="button" onClick={function() { setFile(null); setPreview(null); }} className="absolute top-2 right-2 p-1 bg-black/50 rounded-full text-white"><X className="w-4 h-4" /></button>
            </div>
          ) : (
            <div onClick={function() { inputRef.current.click(); }} className="w-full h-28 border-2 border-dashed border-gray-300 rounded-lg flex flex-col items-center justify-center cursor-pointer hover:border-[#3B82F6] transition-colors" data-testid="banner-upload-area">
              <Upload className="w-6 h-6 text-gray-400 mb-1" />
              <p className="text-xs text-gray-500">Clique para fazer upload</p>
              <p className="text-[10px] text-gray-400">JPG, PNG, WebP ou GIF (max 5MB)</p>
            </div>
          )}
          <input ref={inputRef} type="file" accept="image/*" onChange={handleFile} className="hidden" data-testid="banner-file-input" />
        </div>
        <div className="flex justify-end gap-3 pt-1">
          <button type="button" onClick={onCancel} className="px-4 py-2 text-sm text-gray-600 hover:bg-gray-100 rounded-lg">Cancelar</button>
          <button type="submit" disabled={saving || !file} className="px-4 py-2 bg-[#3B82F6] text-white rounded-lg text-sm font-medium hover:bg-blue-600 disabled:opacity-50" data-testid="save-banner-btn">
            {saving ? "Enviando..." : "Publicar Banner"}
          </button>
        </div>
      </form>
    </div>
  );
}
